module.exports = __webpack_public_path__ + "images/stickers/thumbsdown.52c31c27f2fe7d7901f3.png";